export const MAX_LIST_SIZE = 10;

export const SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar';
export const SEARCH_SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar_after_search';
export const REQUEST_REVIEW_SIMPLE = 'user_requests_review_from_mr_simple_sidebar';
export const REMOVE_REVIEWER_EVENT = 'reviewer_removed_from_mr';

export const EVENT_MR_TITLE_UPDATED = 'merge_request:title_updated';
